export function getMouseCoords(event) {
  const rect = event.target.getBoundingClientRect();
  const x = Math.floor(event.clientX - rect.x);
  const y = Math.floor(event.clientY - rect.y);
  return { x, y };
}

export function jsonStringToUint8ClampedArray(str) {
  return Uint8ClampedArray.from(JSON.parse(str));
}

export function $$(selector) {
  return document.querySelector(selector);
}
